import React, { memo } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStoreId } from '@thd-nucleus/experience-context';
import { LandingContainer } from './containers/LandingContainer';

export const LandingPage = memo(() => {
  const storeId = useStoreId();

  const defaultVariables = {
    keyword: null,
    slug: 'move',
    storeId
  };

  return (
    <QueryProvider cacheKey="landing-page" defaultVariables={defaultVariables}>
      <LandingContainer storeId={storeId} />
    </QueryProvider>
  );
});
